<template>
  <pages-wrapper>
    <div class="sizes">
      <h1>{{ pageTitle }}</h1>

      <div v-html="PAGE_CONTENT" />

      <h2>Как произвести замеры?</h2>

      <div class="sizes-guide">
        <ol>
          <li>
            <span>Рост</span>
            <p>Измеряется от пола до макушки головы. Важно стоять прямо, без напряжения, не сутулясь и не сгибая ноги в коленях.</p>
          </li>
          <li>
            <span>Длина шагового шва</span>
            <p>Для джинсов и, иногда, для брюк, используется показатель «длина шагового шва», который  измеряется в дюймах и обозначает длину изделия по внутренней стороне ноги (от паха до пола). </p>
          </li>
          <li>
            <span>Обхват шеи</span>
            <p>Измеряется окружность шеи по тому месту, где обычно застегивается воротник</p>
          </li>
          <li>
            <span>Обхват груди</span>
            <p>Измеряется по самому широкому месту груди. Чтобы обеспечить удобную посадку,  не тяните измерительную ленту слишком сильно, сантиметр должен плотно, но без натяжки прилегать к телу. Рекомендуется снимать мерки в белье, с которым планируется носить изделие.</p>
          </li>
          <li>
            <span>Обхват талии</span>
            <p>Измеряется по самому узкому месту талии. Чтобы обеспечить удобную посадку,  не тяните измерительную ленту слишком сильно, сантиметр должен плотно, но без натяжки прилегать к телу.</p>
          </li>
          <li>
            <span>Обхват бедер</span>
            <p>Измеряется по самому широкому месту бедер </p>
          </li>
        </ol>

        <img :src="sizesImage" alt="sizes-hint">
      </div>

      <h2>Гид по размерам</h2>

      <ui-tabs
        v-model="tab"
        :items="tabs"
      />
    </div>
  </pages-wrapper>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import PagesWrapper from '../../components/info-pages/pages-wrapper';
import sizesImg from '../../assets/images/sizes.jpg';
import pageMetaMixin from '@/mixins/page-meta-mixin';

export default {
  name: 'sizes',

  metaInfo() {
    return this.getPageMeta({ pageTitle: this.pageTitle });
  },

  components: {
    PagesWrapper
  },

  mixins: [pageMetaMixin],

  data() {
    return {
      pageTitle: 'Размеры одежды',
      tab: 'women',
      sizesImage: sizesImg
    }
  },

  computed: {
    ...mapGetters({
      PAGE_CONTENT: 'staticPages/page',
      GET_FRAGMENT: 'staticPages/fragments',
    }),

    tabs() {
      return [
        {
          key: 'women',
          name: 'Женщины',
          content: this.GET_FRAGMENT(this.activeSlot),
          contentClass: 'sizes-tables',
        },
        {
          key: 'men',
          name: 'Мужчины',
          content: this.GET_FRAGMENT(this.activeSlot),
          contentClass: 'sizes-tables',
        },
        {
          key: 'girls',
          name: 'Девочки',
          content: this.GET_FRAGMENT(this.activeSlot),
          contentClass: 'sizes-tables',
        },
        {
          key: 'boys',
          name: 'Мальчики',
          content: this.GET_FRAGMENT(this.activeSlot),
          contentClass: 'sizes-tables',
        },
        {
          key: 'accessories',
          name: 'Аксессуары',
          content: this.GET_FRAGMENT(this.activeSlot),
          contentClass: 'sizes-tables',
        },
      ];
    },

    activeSlot() {
      switch(this.tab) {
        case 'women':
          return 'sizes_info_women';
        case 'men':
          return 'sizes_info_men';
        case 'girls':
          return 'sizes_info_girls';
        case 'boys':
          return 'sizes_info_boys';
        case 'accessories':
          return 'sizes_info_accessories';
        default:
          return '';
      }
    }
  },

  watch: {
    tab() {
      if (this.GET_FRAGMENT(this.activeSlot)) return;

      this.LOAD_FRAGMENT({slotName: this.activeSlot});
    }
  },



  methods: {
    ...mapActions({
      LOAD_STATIC_PAGE: 'staticPages/loadStaticPage',
      LOAD_FRAGMENT: 'staticPages/loadStaticFragments'
    })
  },

  serverPrefetch() {
    return Promise.all([
      this.LOAD_STATIC_PAGE(),
      this.LOAD_FRAGMENT({slotName: this.activeSlot})
    ])
  }
};
</script>

<style lang="scss">
.sizes {
  h1::after {
    content: '';
    display: block;
    width: 100%;
    height: 1px;
    margin-top: 12px;
    background-color: $gray_lu;
  }

  p {
    margin-top: 24px;
  }

  ul {
    padding: 0 16px;

    & li {
      margin-top: 0;
      font-size: 14px;
      line-height: 20px;
    }

    & > li::before,
    & > li::after {
      content: none;
    }
  }

  &-guide {
    img {
      width: 100%;
      margin-top: 24px;
    }
  }

  &-tables { // временный фикс, чтобы избежать рывков при первичной загрузке таба
    min-height: 1000px;
  }
}

.table {
  margin-top: 32px;
  margin-right: -24px;

  h2 {
    margin: 0;
    font-size: 16px;
    font-family: Gilroy, sans-serif;
    line-height: 24px;
    font-weight: 600;
  }

  .wrapper {
    position: relative;
    margin-top: 16px;
    overflow-x: scroll;
  }

  table {
    width: 100%;
    font-size: 12px;
    line-height: 24px;
    font-weight: 600;
    border-collapse: collapse;
  }

  tr {
    height: 48px;
    border-bottom: 1px solid $gray_lu;
    box-sizing: border-box;

    &:first-child {
      border-color: $gray_bgr;
      background-color: $gray_bgr;
    }

    &:last-child {
      border-bottom: none;
    }
  }

  td {
    min-width: 56px;
    padding: 0 12px;
    text-align: center;
    white-space: nowrap;

    &:first-child {
      min-width: 144px;
      text-align: left;
      font-weight: normal;
    }
  }
}
@include breakpoint("tablet") {
  .sizes {
    &-guide {
      display: flex;
      align-items: flex-start;

      img {
        width: 288px;
        margin-left: 24px;
        margin-top: 0;
      }
    }
  }

  .table {
    max-width: 666px;
    margin-right: 0;

    &::after {
      display: none;
    }

    .wrapper {
      overflow-x: auto;
    }

    table {
      overflow-x: auto;
      font-size: 14px;
      line-height: 24px;
    }

    td {
      min-width: 50px;

      &:first-child {
        min-width: 170px;
      }
    }
  }
}

@include breakpoint("desktop") {
  .sizes {
    h1::after {
      margin-top: 16px;
    }

    p {
      margin-top: 32px;
    }

    ul {
      padding: 0;

      & > li {
        font-size: 16px;
        line-height: 24px;
      }
    }

    &-guide {
      margin-top: 22px;
    }
  }

  .table {
    max-width: none;
    margin-top: 40px;

    td {
      &:first-child {
        min-width: 240px;
      }
    }
  }
}
</style>
